import { render, staticRenderFns } from "./text-editor-sm.vue?vue&type=template&id=071e486d&"
import script from "./text-editor-sm.vue?vue&type=script&lang=ts&"
export * from "./text-editor-sm.vue?vue&type=script&lang=ts&"
import style0 from "./text-editor-sm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports